import {
    registerSelectEditControl
} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {Component, Injector} from "@angular/core";
import {ContactSearchModel} from "../contact-search.model";
import {ContactSearchPageComponent} from "../contact-search-page/contact-search-page.component";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {ContactEditPageComponent} from "../contact-edit-page/contact-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-contact-single-select-edit-control",
    templateUrl: "../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(ContactSingleSelectEditControlComponent),
        provideSearchModel(ContactSearchModel)
    ]
})
export class ContactSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<ContactSearchModel> {
    constructor(model: ContactSearchModel, injector: Injector) {
        super(model, injector, "firstName", "lastName");

        this.extendedSearchComponent = ContactSearchPageComponent;
        this.extendedEditComponent = ContactEditPageComponent;
    }
}
